import { AttendantCompanyTypeEnum } from 'constants/loanApplication';
import { getConditionalArray, normalizeRequestPhoneNumber } from 'utils/data';

export const getClosingCompanyValuesToSend = ({ form, closingCompany }) => [
  {
    attendantCompanyId: form.attendantCompanyId.value,
    escrowNumber: form.escrowNumber,
    closerContactPhone: normalizeRequestPhoneNumber(form.closerContactPhone),
    closerName: form.closerName,
    closerContactEmail: form.closerContactEmail,
    closerLicenseNumber: form.closerLicenseNumber,
    closingCompanyType: closingCompany.closingCompanyType,
    location: {
      attendantCompanyLocationId: form.attendantCompanyLocationId,
      name: form.name,
      streetAddress: form.streetAddress,
      city: form.city,
      state: form.state,
      zipCode: form.zipCode,
      suite: form.suite,
      accountName: form.accountName,
      routingNumber: form.routingNumber,
      accountNumber: form.accountNumber,
      licenseNumber: form.licenseNumber,
    },
  },
];

const getAttorneyValuesToSend = ({ data, type }) => {
  if (!data.attendantCompanyId) {
    return null;
  }

  return {
    attendantCompanyId: data.attendantCompanyId.value,
    closingCompanyType: type,
    location: {
      attendantCompanyLocationId: data.attendantCompanyLocationId,
      name: data.name,
      streetAddress: data.streetAddress,
      city: data.city,
      state: data.state,
      zipCode: data.zipCode,
      suite: data.suite,
      licenseNumber: data.licenseNumber,
      phone: data.phone,
      email: data.email,
      contactPhone: data.contactPhone,
      contactEmail: data.contactEmail,
      contactPerson: data.contactPerson,
    },
  };
};

export const getAttorneysValuesToSend = ({ form, isSellersAttorney, isBuyersAttorney }) => {
  if (isSellersAttorney || isBuyersAttorney) {
    return [
      getAttorneyValuesToSend({
        data: form,
        type: isSellersAttorney
          ? AttendantCompanyTypeEnum.SELLER_ATTORNEY
          : AttendantCompanyTypeEnum.BUYER_ATTORNEY,
      }),
    ];
  }

  return [
    ...getConditionalArray(!!form.seller?.attendantCompanyId, () => [
      getAttorneyValuesToSend({
        data: form.seller,
        type: AttendantCompanyTypeEnum.SELLER_ATTORNEY,
      }),
    ]),
    ...getConditionalArray(!!form.buyer?.attendantCompanyId, () => [
      getAttorneyValuesToSend({ data: form.buyer, type: AttendantCompanyTypeEnum.BUYER_ATTORNEY }),
    ]),
  ];
};

export const getInitialApplicationData = ({ isAddAttorneys, closingCompany }) => {
  if (!isAddAttorneys) {
    return closingCompany;
  }

  return {
    seller: {
      type: AttendantCompanyTypeEnum.SELLER_ATTORNEY,
    },
    buyer: {
      type: AttendantCompanyTypeEnum.BUYER_ATTORNEY,
    },
  };
};

export const checkIsLocationEmpty = ({ form, isAddAttorneys }) => {
  if (!isAddAttorneys) {
    return !form.attendantCompanyLocationId;
  }

  const isSellersAttorneyLocationEmpty =
    !!form.seller?.attendantCompanyId && !form.seller?.attendantCompanyLocationId;
  const isBuyerAttorneyLocationEmpty =
    !!form.buyer?.attendantCompanyId && !form.buyer?.attendantCompanyLocationId;

  return isSellersAttorneyLocationEmpty || isBuyerAttorneyLocationEmpty;
};

const checkIsFieldsEmpty = data =>
  !data.streetAddress || !data.city || !data.state || !data.zipCode;

export const checkIsFeeProviderMissedFields = ({ form, isAddAttorneys }) => {
  if (!isAddAttorneys) {
    return checkIsFieldsEmpty(form);
  }

  const isSellersFieldsEmpty = !!form.seller?.attendantCompanyId && checkIsFieldsEmpty(form.seller);
  const isBuyerAttorneyFieldsEmpty =
    !!form.buyer?.attendantCompanyId && checkIsFieldsEmpty(form.buyer);

  return isSellersFieldsEmpty || isBuyerAttorneyFieldsEmpty;
};
